var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"viewBox":"0 0 13 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 2.90918H12.5996V4.6058H0V2.90918ZM0 6.30347H7.87427V8.00009H0V6.30347Z","fill":"#333333"}}),_c('path',{attrs:{"d":"M0 0H12.5996V1.45454H0V0Z","fill":"#333333"}})])}
var staticRenderFns = []

export { render, staticRenderFns }